import React from 'react';
import { Star } from 'lucide-react';
const reviews = [{
  name: 'Jennifer Rollin-Busby',
  date: 'April 8, 2026',
  text: 'Made the experience stress free!'
}, {
  name: 'Kirsty Millar',
  date: 'February 18, 2026',
  text: 'Very helpful and informative. Will definitely use again.'
}, {
  name: 'Oscar Low',
  date: 'January 15, 2026',
  text: 'Jerry is very helpful and puts a lot of effort in and helped me buy my first house'
}, {
  name: 'Sharn Jordan',
  date: 'December 1, 2025',
  text: ''
}, {
  name: 'Jack Skelly',
  date: 'November 26, 2025',
  text: "Absolutely flawless, Jerry helps you through stressful situations step by step. Wouldn't use anyone else."
}];
export function ReviewsSection() {
  return <section className="py-16 sm:py-20 bg-background-body" data-id="element-114">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-115">
        <div className="text-center mb-10" data-id="element-116">
          <h2 className="text-3xl font-heading text-text-title mb-3" data-id="element-117">
            What my clients say
          </h2>
          <div className="inline-flex items-center gap-2" data-id="element-118">
            <div className="flex text-text-warning-default" data-id="element-119">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-120" />)}
            </div>
            <span className="text-text-default font-body-semi-bold" data-id="element-121">
              5.0 out of 5 stars
            </span>
            <span className="text-text-dimmed" data-id="element-122">from 99 reviews</span>
          </div>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide -mx-4 px-4 sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8" data-id="element-123">
          {reviews.map((review, idx) => <div key={idx} className="bg-neutral-white border border-border-default rounded-xl p-6 shadow-sm flex flex-col min-w-[280px] sm:min-w-[300px] flex-shrink-0 snap-start" data-id="element-124">
              <div className="flex text-text-warning-default mb-4" data-id="element-125">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-126" />)}
              </div>
              {review.text ? <p className="text-text-default italic flex-grow mb-4 leading-relaxed" data-id="element-127">
                  "{review.text}"
                </p> : <div className="flex-grow mb-4" data-id="element-128" />}
              <div className="mt-auto pt-4 border-t border-border-default" data-id="element-129">
                <p className="font-body-semi-bold text-text-title text-sm" data-id="element-130">
                  {review.name}
                </p>
                <p className="text-xs text-text-dimmed mt-1" data-id="element-131">{review.date}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}